export type DashboardAssistantExecutionMode = 'assistant-ui' | 'inngest';

/**
 * Inngest is the default. Streaming runs only when the mode is explicitly
 * 'assistant-ui', the documented rollback, so an environment that never set
 * the variable (a PR preview, a fresh branch) gets what dev and prod run.
 */
export function resolveDashboardAssistantExecutionMode(
  configured: string | undefined,
): DashboardAssistantExecutionMode {
  return configured === 'assistant-ui' ? 'assistant-ui' : 'inngest';
}

export const DASHBOARD_ASSISTANT_EXECUTION_MODE: DashboardAssistantExecutionMode =
  resolveDashboardAssistantExecutionMode(
    import.meta.env.VITE_APP_DASHBOARD_ASSISTANT_EXECUTION_MODE ||
      import.meta.env.VITE_DASHBOARD_ASSISTANT_EXECUTION_MODE,
  );

export function isInngestAssistantExecutionEnabled() {
  return DASHBOARD_ASSISTANT_EXECUTION_MODE === 'inngest';
}
